<template>
    <article class="articles" @wheel="handleWheel">
        <div class="article active" data-a="0">
            <div class="article__image"
                style="background: url(https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=2550&q=80)">
            </div>
        </div>
        <div class="article active" data-a="1">
            <div class="article__image"
                style="background: url(https://images.unsplash.com/photo-1584345604476-8ec5e12e42dd?ixid=MXwxMjA3fDB8MHxzZWFyY2h8Mnx8bXVzdGFuZ3xlbnwwfHwwfA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1100&q=60)">
            </div>
        </div>
        <div class="article active" data-a="2">
            <div class="article__image"
                style="background: url(https://images.unsplash.com/photo-1485965120184-e220f721d03e?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=2550&q=80)">
            </div>
        </div>
        <div class="article active" data-a="3">
            <div class="article__image"
                style="background: url(https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=2691&q=80)">
            </div>
        </div>
        <div class="article active" data-a="4">
            <div class="article__image"
                style="background: url(https://images.unsplash.com/photo-1563448838550-927e051a831f?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MTIyfHxkcnVtJTIwYW5kJTIwYmFzc3xlbnwwfHwwfA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1100&q=60)">
            </div>
        </div>
    </article>
</template>

<script>
    export default {
        data() {
            return {
                scroll: {
                    position: 0,
                    current: 0,
                    next: 0,
                    interval: 500,
                    sensitivity: 1,
                    direction: 0,
                    triggerTime: 200
                },
                styles : {
                    current: null,
                    next: null
                },
                window: {
                    height: 0
                },
                intersection: {
                    observer: null,
                    options: null
                },
                numberOfProjects: null
            }
        },
        mounted() {
            this.numberOfProjects = this.$el.children.length
            this.window.height = window.innerHeight
        },
        methods: {
            intersectionHandler (event) {

            },
            handleWheel(event) {
                // Scroll Position is always inside the given range of (0...COMPLETE INTERVAL)
                this.scroll.position = this.mod(parseInt(this.scroll.position) + (parseInt(event.deltaY) * this.scroll
                    .sensitivity), this.numberOfProjects * this.scroll.interval)
                this.scroll.current = this.mod(Math.floor(this.scroll.position / this.scroll.interval), this
                    .numberOfProjects)


                if (event.deltaY > 0) {
                    this.scroll.direction = 1
                }
                if (event.deltaY < 0) {
                    this.scroll.direction = -1
                }

                this.scroll.next = this.mod(this.scroll.current + this.scroll.direction, this.numberOfProjects)

                this.handleBehaviour()
            },
            handleBehaviour() {
                for (let article of this.$el.children) {
                    if (article.attributes["data-a"].value == this.scroll.current) {
                        article.classList.add('active')
                    } else {
                        article.classList.remove('active')

                        this.resetDefaultStyles(article)
                    }
                }

                let current = this.$el.querySelector('.article[data-a="' + this.scroll.current + '"]')
                let next = this.$el.querySelector('.article[data-a="' + this.scroll.next + '"]')

                let position = this.mod(this.scroll.position, this.scroll.interval)
                let direction = this.scroll.direction

                let mapped = {
                    position: {
                        down: null,
                        up: null
                    },
                    clip: {
                        down: null,
                        up: null
                    }
                }

                mapped.position.down = this.mapRange(position, 0, this.scroll.interval, 100, 0)
                mapped.clip.down = this.mapRange(position, 0, this.scroll.interval, 0, 100)


                

                // Scroll Direction Down
                if (direction == 1) {
                    this.styles.current = {
                        "clip-path" : "inset(0 0 " + mapped.clip.down + "% 0)",
                        "z-index" : "2",
                        "background" : "red"
                    }

                    this.styles.next = {
                        "transform": "translateY(" + mapped.position.down + "%)",
                        "z-index" : "1",
                        "background" : "blue"
                    }
                }

                // Scroll Direction Up
                else {
                    this.styles.current = {
                        "transform": "translateY(" + mapped.position.down + "px)",
                        "z-index" : "2"
                    }

                    this.styles.next = {
                        "clip-path" : "inset(0 0 " + mapped.position.clip + "% 0)",
                        "z-index:" : "1"
                    }
                }


                Object.assign(current.style, this.styles.current)
                Object.assign(next.style, this.styles.next)          

                this.scrollStopHandler(current, next)

                next.classList.add('active')
            },
            scrollStopHandler(current, next) {
                // setTimeout(() => { 
                    
                //     this.styles.current = {
                //         "clip-path" : "inset(0 0 0 0)",
                //         "transform" : "translateY(0%)",
                //         "z-index" : "2",
                //         "background" : "red"
                //     }

                //     this.styles.next = {
                //         "transform": "translateY(100%)",
                //         "z-index" : "1",
                //         "background" : "blue"
                //     }



                //     Object.assign(current.style, this.styles.current)
                //     Object.assign(next.style, this.styles.next)    

                // }, this.scroll.triggerTime, current, next)
            },
            resetDefaultStyles(article) {
                let style = {
                    "clip-path" : "none",
                    "transform" : "none",
                    "z-index" : "0",
                    "background" : "none"
                }
                Object.assign(article.style, style)
            },
            mod(n, m) {
                return ((n % m) + m) % m;
            },
            // linearly maps value from the range (a..b) to (c..d)
            mapRange(value, a, b, c, d) {
                // first map value from (a..b) to (0..1)
                value = (value - a) / (b - a);
                // then map it from (0..1) to (c..d) and return it
                return c + value * (d - c);
            },
            scrollStop(callback) {
                // Make sure a valid callback was provided
                if (!callback || typeof callback !== 'function') return;

                // Setup scrolling variable
                var isScrolling;

                // Listen for scroll events
                window.addEventListener('scroll', function (event) {

                    // Clear our timeout throughout the scroll
                    window.clearTimeout(isScrolling);

                    // Set a timeout to run after scrolling ends
                    isScrolling = setTimeout(function() {

                        // Run the callback
                        callback();

                    }, 66);

                }, false);
            }
        }
    }
</script>

<style lang="scss" scoped>
    
    .articles {
        overflow: hidden;

        .article {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100vh;
            // scroll-snap-align: start;
            background-size: cover;
            border: 2px red dashed;
            display: none;
            transition: 200ms ease;
            transform: none;
            clip-path: none;

            &.active {
                display: block;
            }

            &__image {
                position: relative;
                top: 50%;
                left: 50%;
                transform: translateX(-50%) translateY(-50%);
                width: 82rem;
                height: 60rem;
                max-height: 80vh;
                background-size: cover !important;
                background-position: center center;
            }
        }
    }
</style>